import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import XLSX from 'xlsx';
import moment from 'moment';
import * as actions from '../reducers/list'
import * as http from '../../../../../util/http';
import {referDomains} from '../../../../../util/consts';
import DateFormat from '../../../../../util/dateFormat'


const styles = theme => ({
    root: {
        display:'flex'
    },
    paper: {
        // minHeight: 700,
        minWidth: 360,
        display:'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing.unit,
        marginRight: 20,
        boxSizing:'border-box'
    },
    button: {
        margin: theme.spacing.unit
    },
    columns: {
        display: 'flex',
        alignItems: 'center'
    },
    column: {
        display: 'block',
        flexBasis: 0,
        flexGrow: 1,
        flexShrink: 1,
        padding: '.75rem',
        textAlign: 'center'
    }
});

class Icenter extends React.Component{ 
    componentDidMount() {
        const {dispatch}  = this.props
        if (http.isRoot() || http.isJuan() || http.isShouQianRole()) { // 售前
            dispatch(actions.getSList());
        }
        if (http.isRoot() || http.isJuan() || http.isTechRole()) { // 技术
            dispatch(actions.getTList());
        }
    }
    changeSquery(key, value) {
        const {dispatch}  = this.props;
        dispatch({type: actions.CHANGE_SQUERY,key,value})
        dispatch(actions.getSList());
    }
    changeTquery(key, value) {
        const {dispatch}  = this.props;
        dispatch({type: actions.CHANGE_TQUERY,key,value})
        dispatch(actions.getTList());
    }
    downloadData = (event) => {
        const {squery: {start_time, end_time}, sdata: {_sdData = [], _jzhzData= [], _copyData= [], _myData= []}} = this.props;
        event.preventDefault();
        const wb = XLSX.utils.book_new();

        const header = ['订单模块', '旺旺号', '电话', '邮箱', '年限', '订单金额', '业务员', '订单状态', '店铺来源', '付款方式', '创建时间'];

        function retItem(mod, item) {
            return {
                '订单模块': mod, 
                '旺旺号': item.aliwangwang, 
                '电话': item.phone, 
                '邮箱': item.email, 
                '年限': item.buyYear, 
                '订单金额': item.orderMoney, 
                '业务员': item.accountName, 
                '订单状态': item.status, 
                '店铺来源': (referDomains.find(it => it.value === item.referDomain) || {name: '双德'}).name,
                '付款方式': item.paymentMethod,
                '实际退款金额': item.refundMoney,
                '创建时间': DateFormat(new Date(item.createTime),'yyyy-MM-dd')
            }
        }
        const retData = [
            ..._sdData.map(item => retItem('森动订单', item)),
            ..._jzhzData.map(item => retItem('建站盒子订单', item)),
            ..._copyData.map(item => retItem('仿站订单', item)),
            ..._myData.map(item => retItem('模版订单', item)),
        ]
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(retData, {header}), '订单');
        // const ws_sd = XLSX.utils.json_to_sheet(_sdData, {header: Object.keys(_sdData[0] || {})});
        // const ws_jzhz = XLSX.utils.json_to_sheet(_jzhzData, {header: Object.keys(_jzhzData[0] || {})});
        // const ws_copy = XLSX.utils.json_to_sheet(_copyData, {header: Object.keys(_copyData[0] || {})});
        // const ws_my = XLSX.utils.json_to_sheet(_myData, {header: Object.keys(_myData[0] || {})});

        // XLSX.utils.book_append_sheet(wb, ws_sd, '森动订单');
        // XLSX.utils.book_append_sheet(wb, ws_jzhz, '建站盒子订单');
        // XLSX.utils.book_append_sheet(wb, ws_copy, '仿站订单');
        // XLSX.utils.book_append_sheet(wb, ws_my, '模版订单');

        XLSX.writeFile(wb, `${start_time}到${end_time}订单导出.xlsx`);
    }

    downloadRenewData = (event) => {
        event.preventDefault();

        const date = moment().format('YYYY-MM-DD');
        Promise.all(['hk1.caihongjianzhan.com', 'hk2.caihongjianzhan.com', 'hk3.caihongjianzhan.com', 'hk4.caihongjianzhan.com', 'hk11.caihongjianzhan.com', 'cn3.caihongjianzhan.com', 'cn2.caihongjianzhan.com', 'cn4.caihongjianzhan.com'].map(host => {
            return http.get(`http://${host}/api/get-due-project?date=${date}`)
        }))
        .then((data) => {
            let retData = [];
            data.forEach(item => retData = retData.concat(item.projects))

            console.info(retData);
            return retData;
        })
        .then((retData) => {
            const form = {
                "logic":"or",
                "filters": retData.map(item => {
                    return {"field": "customerAdminName", "operator": "eq", "value": item.name}
                })
            }
            return Promise.all([
                http.post(`/order-copy/list?page=0&size=10000`, form),
                http.post(`/order-my/list?page=0&size=10000`, form),
            ])
            .then((orderData) => {
                orderData.forEach(orderArr => {
                    orderArr.data.list.forEach(item => {
                        const retItem = retData.find(it => it.name === item.customerAdminName);
                        if (retItem) {
                            retItem.creator = item.accountName;
                        }
                    })
                })
            })
            .then(() => retData)
        })
        .then(retData => {
            const wb = XLSX.utils.book_new();
            const header = ['项目名', '到期时间', '手机号码', '创建人'];

            XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(retData.map(item => {
                return {
                    '项目名': item.name,
                    '到期时间': moment(item.due_time).format('YYYY-MM-DD'),
                    '手机号码': item.phone,
                    '创建人': item.creator || ''
                }
            }), {header}), '订单');

            XLSX.writeFile(wb, `${moment().add(1, 'M').format('YYYYMM')}到期订单.xlsx`);
        })
    }
    render() {
        const { classes,dispatch,user,changeMessage, squery, tquery, sdata: {sdData, jzhzData, copyData, myData}, tdata: {devData, afterData}} = this.props
        return (<div>
            {false && <div style={{display: 'flex'}}>
                <Paper className={classes.paper}>
                    <Typography variant="title">个人信息</Typography>
                    <TextField 
                        id="name"
                        label="用户名"
                        margin="normal"
                        value={changeMessage.name || user.name}
                        onChange={(e) => dispatch({type: actions.CHANGE_MESSAGE,key: 'name',value: e.target.value})}
                    />
                    <TextField 
                        id="phone"
                        label="手机号"
                        margin="normal"
                        value={changeMessage.phone || user.phone}
                        onChange={(e) => dispatch({type: actions.CHANGE_MESSAGE,key: 'phone',value: e.target.value})}
                    />
                    <Button variant="outlined" className={classes.button} color="primary" disabled={!changeMessage.name && !changeMessage.phone} onClick={() => dispatch(actions.updateUser(user.id))}>保存</Button>
                </Paper>
                {(http.isRoot() || http.isJuan() || http.isShouHouRole() || http.isTechShouHouRole()) && <Paper className={classes.paper}>
                    <Typography variant="title">登录后台</Typography>
                    <p><a href={`http://${user.id}.bizcn.xuansiwei.com/init.php`} target="_blank">点击登录商务中国后台</a></p>
                    <p><a href={`http://${user.id}.iisp.xuansiwei.com/init.php`} target="_blank">点击登录建站盒子后台</a></p>
                    <p><a href={`http://cn1.xuansiwei.com:5090/login?id=${user.id}&type=cn1`} target="_blank">点击登录阿里云国内cn1宝塔</a></p>
                    <p><a href={`http://hk1.mengb123.com:5090/login?id=${user.id}&type=hk1`} target="_blank">点击登录阿里云香港hk1宝塔</a></p>
                    <p><a href={`http://hk2.mengb123.com:5090/login?id=${user.id}&type=hk2`} target="_blank">点击登录阿里云香港hk2宝塔</a></p>
                </Paper>}

                {/* <Paper className={classes.paper}>
                    <Typography variant="title">公司IP</Typography>
                    <p>纸圭IP: {localStorage.getItem('纸圭ip')}</p>
                    <p>双德IP: {localStorage.getItem('双德ip')}</p>
                </Paper> */}

                <Paper className={classes.paper}>
                    <Typography variant="title">公司其他系统入口</Typography>
                    <p><a href={`http://zqxfd.kaixinjianzhan.com/member/pages/customer/genjin.html`} target="_blank">客户管理</a></p>
                    <p><a href={`http://mmtgabx4294.temp.cn2.jiaogeiwo.cn/admin/pages/resource/case.html`} target="_blank">客户案例中心</a></p>
                    <p><a href={`http://mmtgabx4294.cn2.jiaogeiwo.cn/?name=mmtgabx4294&password=13692240553`} target="_blank">挣钱小分队的十万个为什么（员工手册）管理后台登录</a></p>
                    <p><a href={`http://mmtgabx4294.cn2.jiaogeiwo.cn/?name=mmtgabx4294&password=13692240553`} target="_blank">开心建站（客户教程）管理后台登录</a></p>
                    <p><a href={`http://mmtgabx4294.temp.cn2.jiaogeiwo.cn/admin/pages/resource/article.html`} target="_blank">文章素材库</a></p>
                    <p><a href={`http://mmtgabx4294.temp.cn2.jiaogeiwo.cn/admin/pages/resource/picture.html`} target="_blank">图片素材库</a></p>
                </Paper>
            </div>}
            {(http.isRoot() || http.isJuan() || http.isShouQianRole()) && <Paper style={{marginTop: 16}}>
                <Grid container spacing={8} alignItems="baseline" style={{marginLeft: 16}}>
                    <Grid item>
                        <TextField
                            type="date"
                            label="选择开始时间"
                            margin="normal"
                            style={{minWidth: 200}}
                            value={squery.start_time}
                            onChange={(event) => this.changeSquery('start_time', event.target.value)}
                        >
                        </TextField>
                    </Grid>
                    <Grid item>
                        <TextField
                            type="date"
                            label="选择结束时间"
                            margin="normal"
                            style={{minWidth: 200}}
                            value={squery.end_time}
                            onChange={(event) => this.changeSquery('end_time', event.target.value)}
                        >
                        </TextField>
                    </Grid>
                    {(http.isRoot() || http.isJuan()) && <Grid item>
                        <Button onClick={(event) => this.downloadData(event)}>下载</Button>
                    </Grid>}
                    {(http.isRoot() || http.isJuan()) && <Grid item>
                        <Button onClick={(event) => this.downloadRenewData(event)}>导出要续费订单</Button>
                    </Grid>}
                    {/* <Grid item style={{paddingLeft: 24}}>新订单: 1000, 续费订单: 5000, 总订单: 15000, 平均订单: 5000</Grid> */}
                </Grid>
                {sdData.list && <div className={classes.columns}>
                    <div className={classes.column}>森动订单统计</div>
                    <div className={classes.column}>
                        {sdData.list.map(value => {
                        return <p>{value.name}: 待付款:{value.unpain}, 已付款: {value.pain} (续费: {value.renew}), 退款: {value.refund}</p>
                        })}
                    </div>
                    <div className={classes.column}>合计: 待付款:{sdData.total.unpain}, 已付款: {sdData.total.pain} (续费: {sdData.total.renew}), 退款: {sdData.total.refund}</div>
                </div>}
                {jzhzData.list && <div className={classes.columns}>
                    <div className={classes.column}>建站盒子订单统计</div>
                    <div className={classes.column}>
                        {jzhzData.list.map(value => {
                        return <p>{value.name}: 待付款:{value.unpain}, 已付款: {value.pain} (续费: {value.renew}), 退款: {value.refund}</p>
                        })}
                    </div>
                    <div className={classes.column}>合计: 待付款:{jzhzData.total.unpain}, 已付款: {jzhzData.total.pain} (续费: {jzhzData.total.renew}), 退款: {jzhzData.total.refund}</div>
                </div>}
                {/* {domainData.list && <div className={classes.columns}>
                    <div className={classes.column}>域名订单统计</div>
                    <div className={classes.column}>
                        {domainData.list.map(value => {
                        return <p>{value.name}: 待付款:{value.unpain}, 已付款: {value.pain}, 退款: {value.refund}</p>
                        })}
                    </div>
                    <div className={classes.column}>合计: 待付款:{domainData.total.unpain}, 已付款: {domainData.total.pain}, 退款: {domainData.total.refund}</div>
                </div>} */}
                {copyData.list && <div className={classes.columns}>
                    <div className={classes.column}>仿站订单统计</div>
                    <div className={classes.column}>
                        {copyData.list.map(value => {
                        return <p>{value.name}: 订单数:{value.size}(案例: {value.copy_size}), 已付款: {value.pain} (续费: {value.renew}, 本月退款: {value.month_refund}), 退款: {value.refund}({value.refund_arr.map(item => item.customerAdminName).join(',')})</p>
                        })}
                    </div>
                    <div className={classes.column}>合计: 订单数:{copyData.total.size}(案例: {copyData.total.copy_size}), 已付款: {copyData.total.pain} (续费: {copyData.total.renew}, 本月退款: {copyData.total.month_refund}), 退款: {copyData.total.refund}</div>
                </div>}
                {myData.list && <div className={classes.columns}>
                    <div className={classes.column}>模板建站订单统计</div>
                    <div className={classes.column}>
                        {myData.list.map(value => {
                        return <p>{value.name}: 订单数:{value.size}, 已付款: {value.pain} (续费: {value.renew}, 本月退款: {value.month_refund}), 退款: {value.refund}({value.refund_arr.map(item => item.customerAdminName).join(',')})</p>
                        })}
                    </div>
                    <div className={classes.column}>合计: 订单数:{myData.total.size}, 已付款: {myData.total.pain} (续费: {myData.total.renew}, 本月退款: {myData.total.month_refund}), 退款: {myData.total.refund}</div>
                </div>}
                {myData.list && <div className={classes.columns}>
                    <div className={classes.column}>总计</div>
                    <div className={classes.column}></div>
                    <div className={classes.column}>订单数:{copyData.total.size + myData.total.size}, 已付款: {myData.total.pain + copyData.total.pain + jzhzData.total.pain + sdData.total.pain} (续费: {myData.total.renew + copyData.total.renew + jzhzData.total.renew + sdData.total.renew}, 本月退款: {myData.total.month_refund + copyData.total.month_refund + jzhzData.total.refund + sdData.total.refund}), 退款: {myData.total.refund + copyData.total.refund + jzhzData.total.refund + sdData.total.refund}</div>
                </div>}
            </Paper>}
            {(http.isRoot() || http.isJuan() || http.isTechRole()) && <Paper style={{marginTop: 16}}>
                <Grid container spacing={8} alignItems="baseline" style={{marginLeft: 16}}>
                    <Grid item>
                        <TextField
                            type="date"
                            label="选择开始时间"
                            margin="normal"
                            style={{minWidth: 200}}
                            value={tquery.start_time}
                            onChange={(event) => this.changeTquery('start_time', event.target.value)}
                        >
                        </TextField>
                    </Grid>
                    <Grid item>
                        <TextField
                            type="date"
                            label="选择结束时间"
                            margin="normal"
                            style={{minWidth: 200}}
                            value={tquery.end_time}
                            onChange={(event) => this.changeTquery('end_time', event.target.value)}
                        >
                        </TextField>
                    </Grid>
                </Grid>
                {devData.copyData.list && <div className={classes.columns}>
                    <div className={classes.column}>开发仿站订单统计</div>
                    <div className={classes.column}>
                        {devData.copyData.list.map(value => {
                        return <p>{value.name}: 订单数:{value.size}, 订单金额: {value.sum}, 退款订单数: {value.refund_size}({value.refundArr.map(item => {
                            if (item.status === '退款完成' && item.refundDuty === item.currentAccountName) {
                                return <span style={{color: 'red'}}>{item.customerAdminName},</span>
                            }
                            return <span>{item.customerAdminName},</span>
                        })}), 退款金额: {value.refund_sum}</p>
                        })}
                    </div>
                </div>}
                {devData.myData.list && <div className={classes.columns}>
                    <div className={classes.column}>开发模版订单统计</div>
                    <div className={classes.column}>
                        {devData.myData.list.map(value => {
                        return <p>{value.name}: 订单数:{value.size}, 订单金额: {value.sum}, 退款订单数: {value.refund_size}({value.refundArr.map(item => {
                            if (item.status === '退款完成' && item.refundDuty === item.currentAccountName) {
                                return <span style={{color: 'red'}}>{item.customerAdminName},</span>
                            }
                            return <span>{item.customerAdminName},</span>
                        })}), 退款金额: {value.refund_sum}</p>
                        })}
                    </div>
                </div>}
                {afterData.copyData.list && <div className={classes.columns}>
                    <div className={classes.column}>对接仿站订单统计</div>
                    <div className={classes.column}>
                        {afterData.copyData.list.map(value => {
                        return <p>{value.name}: 订单数:{value.size}, 订单金额: {value.sum}, 退款订单数: {value.refund_size}({value.refundArr.map(item => item.customerAdminName).join(',')}), 退款金额: {value.refund_sum}</p>
                        })}
                    </div>
                </div>}
                {afterData.myData.list && <div className={classes.columns}>
                    <div className={classes.column}>对接模版订单统计</div>
                    <div className={classes.column}>
                        {afterData.myData.list.map(value => {
                        return <p>{value.name}: 订单数:{value.size}, 订单金额: {value.sum}, 退款订单数: {value.refund_size}({value.refundArr.map(item => item.customerAdminName).join(',')}), 退款金额: {value.refund_sum}</p>
                        })}
                    </div>
                </div>}
            </Paper>}
        </div>)
    }  
}


const mapStateToProps = (state) => {
    return {
        ...state.icenter,
        user: state.auth.user.user
    }
}

export default withRouter(
    connect(mapStateToProps)(withStyles(styles)(Icenter))
);




// WEBPACK FOOTER //
// ./src/pages/home/routes/icenter/components/list.js